import React from 'react';
import { FolderOpen, MousePointerClick, Pencil } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-10 md:py-14 px-4" data-id="element-179">
      <div className="max-w-3xl mx-auto text-center" data-id="element-180">
        <div className="inline-block bg-green-500 text-white font-bold px-4 py-1 rounded-full mb-4 shadow-md text-sm" data-id="element-181">
          ✅ LA SOLUCIÓN
        </div>

        <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-3 font-['Oswald'] uppercase" data-id="element-182">
          Pack Completo – Aprende el Cuerpo Humano Jugando
        </h2>

        <p className="text-base text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-183">
          Un sistema completo de Ciencias Naturales organizado por unidades,
          diseñado para que dejes de improvisar y vuelvas a disfrutar enseñar.
        </p>

        <div className="grid grid-cols-3 gap-4" data-id="element-184">
          <div className="flex flex-col items-center" data-id="element-185">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-3 shadow-inner" data-id="element-186">
              <FolderOpen className="w-8 h-8 text-blue-600" data-id="element-187" />
            </div>
            <h3 className="text-sm md:text-lg font-bold text-gray-900 mb-1" data-id="element-188">
              1. Abrís el material
            </h3>
          </div>

          <div className="flex flex-col items-center" data-id="element-189">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-3 shadow-inner" data-id="element-190">
              <MousePointerClick className="w-8 h-8 text-blue-600" data-id="element-191" />
            </div>
            <h3 className="text-sm md:text-lg font-bold text-gray-900 mb-1" data-id="element-192">
              2. Elegís el tomo
            </h3>
          </div>

          <div className="flex flex-col items-center" data-id="element-193">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-3 shadow-inner" data-id="element-194">
              <Pencil className="w-8 h-8 text-blue-600" data-id="element-195" />
            </div>
            <h3 className="text-sm md:text-lg font-bold text-gray-900 mb-1" data-id="element-196">
              3. Lo aplicás en clase
            </h3>
          </div>
        </div>

        <div className="mt-8 pt-4 border-t border-gray-200" data-id="element-197">
          <p className="text-lg font-bold text-gray-800 uppercase tracking-wide" data-id="element-198">
            Sin vueltas. Sin improvisar. Sin perder tiempo.
          </p>
        </div>
      </div>
    </section>;
}